import { VERIFICATION_TYPE_NAMES_SHORT } from 'dashboard/lib/constants/verification';
import { InquiryTemplate } from 'dashboard/models/inquiry-template';
import { REPORT_TEMPLATE_TYPE_TO_LABEL } from 'dashboard/models/report-template';
import { Template } from 'dashboard/models/template';
import Placeholder from 'dashboard/modules/Placeholder';
import { ModuleResource } from 'dashboard/modules/Resource/model';
import { ModuleResourceInquiry } from 'dashboard/modules/ResourceInquiry';
import { ModuleResourceReport } from 'dashboard/modules/ResourceReport';
import { ModuleResourceVerification } from 'dashboard/modules/ResourceVerification';
import { nameDisplay } from 'lib/utils/template';

interface ResourcePlaceholderProps {
  module: ModuleResource;
  allInquiryTemplates?: (InquiryTemplate | Template)[];
  isLoading?: boolean;
}

const ResourcePlaceholder = ({
  module,
  allInquiryTemplates = [],
  isLoading = false,
}: ResourcePlaceholderProps) => {
  const { 'field-key': fieldKey } = module;

  let title: string;

  switch (fieldKey) {
    case 'reports': {
      const reportName =
        REPORT_TEMPLATE_TYPE_TO_LABEL[(module as ModuleResourceReport)['report-template-type']];
      title = `Report module - ${reportName}`;
      break;
    }
    case 'verifications': {
      const verificationName =
        VERIFICATION_TYPE_NAMES_SHORT[(module as ModuleResourceVerification)['verification-type']];
      title = `Verification module - ${verificationName}`;
      break;
    }
    case 'inquiries': {
      const inquiryTemplate = allInquiryTemplates.find(
        (it) => it.id === (module as ModuleResourceInquiry)['inquiry-template'],
      );

      title = inquiryTemplate
        ? `Inquiry module - ${nameDisplay(inquiryTemplate)}`
        : 'Inquiry module';
      break;
    }
    case 'transactions': {
      title = 'Transaction module';
      break;
    }
    default: {
      title = 'Resource module';
      break;
    }
  }

  if (isLoading) {
    return <Placeholder title={title} loading={true} />;
  }
  return <Placeholder title={title} message='No data collected for this case.' />;
};

export default ResourcePlaceholder;
